import { createSlice } from "@reduxjs/toolkit";
import { doGetRoleFeatures, doUpdateRoleFeature } from "./roleFeatures.action";

export interface RoleFeature {
  id: number;
  name: string;
  isCreatePost: boolean;
  isCreateReel: boolean;
  isCreateOpenCall: boolean;
  isPostAuditionVideo: boolean;
  isGoLive: boolean;
  isJoinLive: boolean;
  isSubscriptionRequired: boolean;
  createdAt: number;
}

interface RoleFeaturesState {
  roles: RoleFeature[];
  loading: boolean;
  error: string | null;
  updating: boolean;
}

const initialState: RoleFeaturesState = {
  roles: [],
  loading: false,
  error: null,
  updating: false,
};

const roleFeaturesSlice = createSlice({
  name: "roleFeatures",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetRoleFeatures: () => initialState,
  },
  extraReducers: (builder) => {
    // Get Role Features
    builder
      .addCase(doGetRoleFeatures.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doGetRoleFeatures.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.data;
      })
      .addCase(doGetRoleFeatures.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as any)?.message || "Failed to fetch role features";
      });

    // Update Role Feature
    builder
      .addCase(doUpdateRoleFeature.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(doUpdateRoleFeature.fulfilled, (state, action) => {
        state.updating = false;
        const updatedRole = action.payload.data;
        const index = state.roles.findIndex(
          (role) => role.id === updatedRole.id
        );
        if (index !== -1) {
          state.roles[index] = updatedRole;
        }
      })
      .addCase(doUpdateRoleFeature.rejected, (state, action) => {
        state.updating = false;
        state.error =
          (action.payload as any)?.message || "Failed to update role feature";
      });
  },
});

export const { clearError, resetRoleFeatures } = roleFeaturesSlice.actions;
export default roleFeaturesSlice.reducer;
